<button mat-icon-button [matMenuTriggerFor]="dropmenu" disableRipple>
  @if (!icon && !initialsIcon) {
    <mat-icon class="open-menu-icon">more_horiz</mat-icon>
  }
  @if (initialsIcon) {
    <tidy-initials-icon
      [fullName]="initialsIcon" />
  }
  @if (icon) {
    <tidy-image
      [src]="icon"
      style="width: 20px; opacity: 30%" />
  }
</button>
<mat-menu #dropmenu="matMenu" overlayPanelClass="my-testing-class">
  <ng-content />
</mat-menu>
